import {
  ASSESSMENT_PROJECT_LIST, 
  ASSESSMENT_PROJECT_LIST_SUCCESS, 
  ASSESSMENT_PROJECT_LIST_ERROR,
  ASSESSMENT_PROJECT_SEARCH_SET, 
  ASSESSMENT_PROJECT_SEARCH_CHANGE, 
  ASSESSMENT_PROJECT_PAGE_SET,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_ERROR,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_ERROR,
  ASSESSMENT_PROJECT_SEARCH_DESTINATION,
  ASSESSMENT_PROJECT_SEARCH_DESTINATION_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_DESTINATION_ERROR, 
  ASSESSMENT_PROJECT_SEARCH_CONTRACT,
  ASSESSMENT_PROJECT_SEARCH_CONTRACT_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_CONTRACT_ERROR, 
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE,
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_SUCCESS,
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_ERROR, 
  ASSESSMENT_PROJECT_ADD_SET,
  ASSESSMENT_PROJECT_ADD_MODAL_SET,
  ASSESSMENT_PROJECT_ADD,
  ASSESSMENT_PROJECT_ADD_SUCCESS,
  ASSESSMENT_PROJECT_ADD_ERROR,
  ASSESSMENT_PROJECT_ADD_CHANGE,
  ASSESSMENT_PROJECT_DETAIL,
  ASSESSMENT_PROJECT_DETAIL_SUCCESS,
  ASSESSMENT_PROJECT_DETAIL_ERROR,
  ASSESSMENT_PROJECT_VIEW_MODAL_SET,
  ASSESSMENT_PROJECT_EDIT_CHANGE,
  ASSESSMENT_PROJECT_EDIT_MODAL_SET,
  ASSESSMENT_PROJECT_UPDATE,
  ASSESSMENT_PROJECT_UPDATE_SUCCESS,
  ASSESSMENT_PROJECT_UPDATE_ERROR,
  ASSESSMENT_PROJECT_VIEW_TAB_SET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 100
    }
  },
  add: {
    data: {
      new:{ id_evaluation_state: null, evaluation_state: null, id_assessment: null, assessment: null, id_assessment_type: null, assessment_type: null, id_destination: null, destination: null, id_contract: null, contract: null, code: '', name: '', stakeholder: '', category: ''}
    },
    modal: false,
    loading: false,
    message: '',
    url: '',
    type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      assessment_type: false,
      assessment: false,
      destination: false,
      contract: false,
      evaluation_state: false
    },
    value:{
      assessment_type: false,
      assessment: false,
      destination: false,
      contract: false,
      evaluation_state: false
    },
    evaluation_state:{
      loading: true,
      list:[],
      message: ''
    },
    assessment_type:{
      loading: true,
      list:[],
      message: ''
    },
    assessment:{
      loading: true,
      list:[],
      message: ''
    },
    destination:{
      loading: true,
      list:[],
      message: ''
    },
    contract:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ASSESSMENT_PROJECT_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case ASSESSMENT_PROJECT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case ASSESSMENT_PROJECT_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case ASSESSMENT_PROJECT_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case ASSESSMENT_PROJECT_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment_type:{
            ...state.search.assessment_type,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_type:{
            ...state.search.assessment_type,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment_type:{
            ...state.search.assessment_type,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_ASSESSMENT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment:{
            ...state.search.assessment,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_DESTINATION:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          destination:{
            ...state.search.destination,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_DESTINATION_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          destination:{
            ...state.search.destination,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_DESTINATION_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          destination:{
            ...state.search.destination,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_CONTRACT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          contract:{
            ...state.search.contract,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_CONTRACT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          contract:{
            ...state.search.contract,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_CONTRACT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          contract:{
            ...state.search.contract,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
      
    case ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          evaluation_state:{
            ...state.search.evaluation_state,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          evaluation_state:{
            ...state.search.evaluation_state,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          evaluation_state:{
            ...state.search.evaluation_state,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case ASSESSMENT_PROJECT_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case ASSESSMENT_PROJECT_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case ASSESSMENT_PROJECT_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_assessment: null, assessment: null, id_destination: null, destination: null, id_contract: null, contract: null, code: '', name: '', stakeholder: '', category: ''}
          },
          modal: action.payload
        }
      }
    case ASSESSMENT_PROJECT_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case ASSESSMENT_PROJECT_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case ASSESSMENT_PROJECT_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case ASSESSMENT_PROJECT_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case ASSESSMENT_PROJECT_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case ASSESSMENT_PROJECT_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case ASSESSMENT_PROJECT_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case ASSESSMENT_PROJECT_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case ASSESSMENT_PROJECT_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case ASSESSMENT_PROJECT_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case ASSESSMENT_PROJECT_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case ASSESSMENT_PROJECT_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case ASSESSMENT_PROJECT_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    default:
      return { ...state };
    }

};